/*
 * 抖音 - 热点榜（服务端路由）
 */
export async function fetchDouyinHot() {
  const res = await fetch('/server-api/douyin')
  if (!res.ok) throw new Error(`HTTP ${res.status}`)
  return res.json()
}
